module.exports = __webpack_public_path__ + "media/images/veridapt-inline-logo-d5b4cd2aec2539e981c1498a58365c37.svg";